import axios from "axios";

// setup 2FA (multipart/form-data)
export const setup2FAReq = async (data, idToken, params = undefined) => {
  try {
    // data = { email: "vishal1@codesis.tech", password: "Vishal@00" }
    const form = new FormData();
    form.append("email", data.email);
    form.append("password", data.password);

    const config = {
      headers: { Authorization: `Bearer ${idToken}` },
      params,
    };

    const response = await axios.post("auth/2fa/setup/", form, config);
    return response.data;
  } catch (error) {
    console.error("Error during 2FA setup:", error);
    throw error;
  }
};

// enable 2FA (application/json)
export const enable2FAReq = async (data, idToken, params = undefined) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${idToken}` },
      params,
    };

    const response = await axios.post(
      "auth/2fa/enable/",
      { otp_code: data.otp_code, temp_secret: data.temp_secret },
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error during 2FA enable:", error);
    throw error;
  }
};

// verify 2FA challenge (application/json)
export const verify2FAReq = async (data, idToken, params = undefined) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${idToken}` },
      params,
    };

    const response = await axios.post(
      "auth/2fa/verify/",
      { temp_token: data.temp_token, otp_code: data.otp_code },
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error during 2FA verify:", error);
    throw error;
  }
};

// disable 2FA (empty body)
export const disable2FAReq = async (idToken, params = undefined) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${idToken}` },
      params,
    };

    const response = await axios.post("auth/2fa/disable/", {}, config);
    return response.data;
  } catch (error) {
    console.error("Error during 2FA disable:", error);
    throw error;
  }
};

// 2FA status (empty body)
export const twoFAStatusReq = async (idToken, params = undefined) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${idToken}` },
      params,
    };

    const response = await axios.get("auth/2fa/status/", config);
    return response.data;
  } catch (error) {
    console.error("Error during 2FA status:", error);
    throw error;
  }
};
